export default __webpack_public_path__ + "static/media/Majesty.96533083.png";